export const HRMS_UNAUTHORISED_MESSAGE =
  "You are Not Authorised for this action. Contact Admin.";

export function getHrmsErrorMessage(
  error,
  fallback = "Operation failed"
) {
  if (error?.response?.status === 403) {
    return HRMS_UNAUTHORISED_MESSAGE;
  }

  const detail = error?.response?.data?.detail;

  if (typeof detail === "string" && detail.trim()) {
    return detail;
  }

  if (Array.isArray(detail)) {
    const messages = detail
      .map((item) => {
        if (typeof item === "string") return item;
        return item?.msg || "";
      })
      .filter(Boolean);

    if (messages.length > 0) {
      return messages.join(", ");
    }
  }

  if (typeof error?.userMessage === "string" && error.userMessage.trim()) {
    return error.userMessage;
  }

  if (typeof error?.message === "string" && error.message.trim()) {
    return error.message;
  }

  return fallback;
}

export function showHrmsError(
  error,
  toast,
  fallback = "Operation failed"
) {
  const message = getHrmsErrorMessage(error, fallback);

  if (typeof toast === "function") {
    toast(message);
  }

  return message;
}